import { useEffect, useRef } from "react";

import shimKeyboardEvent from "./shims";
type KeyboardFunc = (e: KeyboardEvent) => void;

const useKeypress = (keys: string | string[], handler: KeyboardFunc) => {
  const eventListenerRef = useRef<KeyboardFunc>();

  useEffect(() => {
    eventListenerRef.current = (event: KeyboardEvent) => {
      shimKeyboardEvent(event);
      if (Array.isArray(keys) ? keys.includes(event.key) : keys === event.key) {
        handler?.(event);
      }
    };
  }, [keys, handler]);

  useEffect(() => {
    const eventListener = (event: KeyboardEvent) => {
      eventListenerRef.current && eventListenerRef.current(event);
    };
    window.addEventListener("keydown", eventListener);
    return () => {
      window.removeEventListener("keydown", eventListener);
    };
  }, []);
};

export default useKeypress;
